import { useLingui } from "@lingui/react/macro";
import { useEffect, useRef } from "react";
import { ResizableSidePanel } from "../pages/ResizableSidePanel";
import { FilePreview } from "./ArtifactFileCard";
import type { SitePreview } from "./site-preview-context";

export function SitePreviewPanel({ preview, onClose }: {
  preview: SitePreview;
  onClose: () => void;
}) {
  const { t } = useLingui();
  const closeButton = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    closeButton.current?.focus({ preventScroll: true });
  }, []);
  return (
    <ResizableSidePanel open panel="site-preview" wide>
      <section
        id="chat-site-preview"
        aria-label={t`Site preview`}
        className="flex h-full min-h-0 min-w-0 flex-col"
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            event.stopPropagation();
            onClose();
          }
        }}
      >
        <FilePreview
          key={JSON.stringify([preview.target, preview.artifactId])}
          {...preview}
          closeButtonRef={closeButton}
          onClose={onClose}
        />
      </section>
    </ResizableSidePanel>
  );
}
